module.exports = __webpack_public_path__ + "static/img/info1.aceab9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info1.png
// module id = 8jzt
// module chunks = 24